import { freeUserUpgradeStep } from '../utils';

export const scheduleCalendarNpoTour = {
  tourKey: 'schedule_calendar_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      target: '[data-tour="schedule-view-filters"]',
      title: 'tours.schedule-calendar-npo.view-filters.title',
      content: 'tours.schedule-calendar-food-mover.view-filters.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="schedule-skip-to-date"]',
      title: 'tours.schedule-calendar-food-mover.skip-to-date.title',
      content: 'tours.schedule-calendar-npo.skip-to-date.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="schedule-legend"]',
      title: 'tours.schedule-calendar-food-mover.legend.title',
      content: 'tours.schedule-calendar-food-mover.legend.content',
      placement: 'left',
    },
    {
      target: '[data-tour="schedule-navigation"]',
      title: 'tours.schedule-calendar-food-mover.navigation.title',
      content: 'tours.schedule-calendar-npo.navigation.content',
      placement: 'left',
    },
    freeUserUpgradeStep,
  ],
};
